import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import DepositMarketShareCountySummaryByState from "../components/SOD/MarketShare/DepositMarketShare/DepositMarketShareCountySummaryByState";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filterField, value));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DepositMarketShareCountySummaryByState);
